import React from "react";
import { ReactNode } from "react";
import { IJobParameterControl } from "./IJobParameterControl";

export class DatePickerJobParameterControl
  implements IJobParameterControl<Date>
{
  CurrentValue: Date;
  DefaultValue: Date;
  Options?: { code: Date; description: string }[] = null;
  ControlID: string;
  Type:
    | "combobox"
    | "text-input"
    | "date-picker"
    | "numeric"
    | "radio-button"
    | "checkbox"
    | "checkbox-list"
    | "multiselect" = "date-picker";
  Caption: string;
  Readonly: boolean;

  constructor() {}

  Render(): ReactNode {
    return (
        <div className="dropdownDataInput"></div>
    );
  }
}
